import { ReactNode, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../config/firebaseConfig";
import { UserMenu } from "../../types/authTypes";
import { TopBar } from "../../types/menuTypes";

import context from "./index";

export default function AuthProvider({ children }: { children: ReactNode }) {
  const [user, loading] = useAuthState(auth);
  const [userMenu, setUserMenu] = useState<UserMenu[]>([]);
  const [currentUser, setCurrentUser] = useState<string>("");
  const [topbar, setTopbar] = useState<TopBar | undefined>();

  const value = {
    user,
    authLoading: loading,
    userMenu,
    setUserMenu,
    currentUser,
    setCurrentUser,
    topbar,
    setTopbar,
  };

  return <context.Provider value={value}>{children}</context.Provider>;
}
